import { render, staticRenderFns } from "./app-pagination.vue?vue&type=template&id=51da2413&scoped=true&"
import script from "./app-pagination.vue?vue&type=script&lang=js&"
export * from "./app-pagination.vue?vue&type=script&lang=js&"
import style0 from "./app-pagination.vue?vue&type=style&index=0&id=51da2413&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51da2413",
  null
  
)

export default component.exports